import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { SITE } from "@/lib/site";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate(location.state?.from?.pathname || "/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-cream-dark bg-white p-10">
        <p className="eyebrow text-ink mb-3">Admin</p>
        <h1 className="font-serif text-3xl text-ink tracking-tight">{SITE.name} — Studio</h1>
        <p className="mt-2 text-sm text-ink-soft">Sign in to manage your video wall and enquiries.</p>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div>
            <Label htmlFor="al-email" className="eyebrow text-ink-soft">Email</Label>
            <Input id="al-email" data-testid="admin-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} className="mt-2 rounded-none h-11" placeholder="you@studio.com" />
          </div>
          <div>
            <Label htmlFor="al-password" className="eyebrow text-ink-soft">Password</Label>
            <Input id="al-password" data-testid="admin-password-input" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} className="mt-2 rounded-none h-11" placeholder="••••••••" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full bg-ink hover:bg-ink disabled:opacity-60 text-cream py-3.5 text-sm font-semibold transition-colors duration-300">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <a href="/" data-testid="back-to-site-link" className="mt-6 inline-block text-xs uppercase tracking-[0.16em] text-ink-soft hover:text-ink transition-colors">
          ← Back to site
        </a>
      </div>
    </div>
  );
}
